import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import Page from '../../pages/Page';
import AdminAccountForm from '../../forms/AdminAccount';

import { saveUserAccount, getUserById, userReceived, unlockAccount, getIsAccountLocked } from '../../../actions/admin';

import styles from './styles.scss';

class AdminEditUser extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isShowingAuthenticationMethods: false
        };

    }

    componentDidMount() {

        this.props.resetUserToEdit();
        return this.props.refreshUser(this.props.match.params.id)
            .then(() => {
                return this.props.getIsAccountLocked(this.props.userAccount.id);
            });
    }

    _saveAccount(values) {

        return this.props.saveUserAccount(values);
    }

    _on2FAChange(e) {

        if (e.target.checked) {
            this.setState({ isShowingAuthenticationMethods: true });
        } else {
            this.setState({ isShowingAuthenticationMethods: false });
        }
    }

    _setInitialShowState(state) {

        this.setState({ isShowingAuthenticationMethods: state });
    }

    render() {

        const { userAccount } = this.props;

        return (
            <Page>
                <PageMeta title="Edit User" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>

                    <PageSection>

                        <Link to="/admin/users" className={styles['back-button']}>
                            &larr; Search Users
                        </Link>

                        {userAccount &&
                            <AdminAccountForm
                                initialValues={userAccount}
                                onSubmit={this._saveAccount.bind(this)}
                                enableReinitialize={true}
                                on2FAChange={this._on2FAChange.bind(this)}
                                setInitialShowState={(state) => this._setInitialShowState(state)}
                                isShowingAuthenticationMethods={this.state.isShowingAuthenticationMethods}
                                unlockAccount={this.props.unlockAccount}
                                isAccountLocked={this.props.isAccountLocked}
                            />
                        }
                    </PageSection>

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = state => {
    return {
        userAccount: state.admin.accountToEdit,
        isAccountLocked: state.admin.isAccountLocked
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetUserToEdit() {
            dispatch(userReceived(null));
        },
        refreshUser(userId) {
            return dispatch(getUserById(userId));
        },
        saveUserAccount(user) {
            return dispatch(saveUserAccount(user));
        },
        unlockAccount(userId) {
            return dispatch(unlockAccount(userId));
        },
        getIsAccountLocked(userId) {
            return dispatch(getIsAccountLocked(userId));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminEditUser);